import callAPI from '../../../API/callSecureAPI'
import endpoints from '../../../API/endpoints'
import { useAuth0 } from '../../../contexts/auth0-context'
import { useMutation } from 'react-query'
import { useInvalidateGetValueNarrativesQuery } from './useInvalidateGetValueNarrativesQuery'

export const useReorderValueMessagesMutation = () => {
    const { getTokenSilently } = useAuth0()

    const reorderValueMessages = async (orderedValueMessageIds: string[]) => {
        try {
            const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            const { url, method } = endpoints.reorderVMs
            return await callAPI(url, method, token, orderedValueMessageIds)
        } catch (e) {
            console.log(e)
        }
    }

    const { invalidateGetValueNarrativesQuery } = useInvalidateGetValueNarrativesQuery()

    return useMutation(reorderValueMessages, {
        onSuccess: async () => {
            await invalidateGetValueNarrativesQuery()
        },
    })
}
